import React, { useEffect, useState } from "react"

import { RefinementListProvided } from "react-instantsearch-core"
import { connectRefinementList } from "react-instantsearch-dom"
import { useIntl } from "react-intl"

import { Body } from "~/components/ui"
import Checkbox from "~/components/ui/Checkbox/Checkbox"
import useAlgoliaFacets, { mergeItems } from "~/hooks/useAlgoliaFacets"
import { sortRefinementListFacetsByLabel } from "~/utils/algoliaUtils"

type LabelNamesType = {
  [key: string]: string
}

const RefinementList = ({
  items,
  refine,
  createURL,
}: RefinementListProvided) => {
  const intl = useIntl()

  const {
    initialFacets: { recipe_type },
  } = useAlgoliaFacets()

  const labelNames: LabelNamesType = {
    creator: intl.formatMessage({
      id: "recipe/search/filters/type/text:by-creators",
    }),
    default: intl.formatMessage({
      id: "recipe/search/filters/type/text:with-video",
    }),
    classic: intl.formatMessage({
      id: "recipe/search/filters/type/text:step-by-step",
    }),
  }

  const [displayedItems, setDisplayedItems] = useState(
    mergeItems({
      activeItems: items ?? [],
      inactiveItems: recipe_type ?? [],
      compareKey: "label",
    })
  )

  useEffect(() => {
    if (items.length > 0) {
      setDisplayedItems(
        mergeItems({
          activeItems: items,
          inactiveItems: recipe_type ?? [],
          compareKey: "label",
        })
      )
    }
  }, [items, recipe_type])

  // TODO: Remove "community" recipe_type from Algolia, it is currently filtered out on the frontend
  return (
    <>
      {displayedItems
        .filter(label => label.label !== "community")
        .sort(sortRefinementListFacetsByLabel)
        .map(item => {
          return (
            <div key={item.value}>
              <Checkbox
                key={item.label + item.isRefined}
                label={item.label}
                value={item.value}
                defaultChecked={item.isRefined}
                onclick={event => {
                  event.preventDefault()
                  refine(item.value)
                  createURL(item.value)
                }}
                disabled={item.count === 0}
              >
                <Body
                  variant="body2"
                  semiBold
                  color={item.count === 0 ? "gray4" : "black"}
                >
                  {labelNames[item.label]}
                </Body>
              </Checkbox>
            </div>
          )
        })}
    </>
  )
}

const CustomRefinmentListType =
  connectRefinementList<RefinementListProvided>(RefinementList)

export default CustomRefinmentListType
